export const attrMessages = [
    {
        text: "Attributing the artist is required per",
        href: "/legal/terms-of-use/#photo-licenses",
        linkText: "CC BY-NC-ND 2.0 License"
    },
    {
        text: "See full",
        href: "https://www.creativecommons.org/licenses/by-nc-nd/2.0/",
        linkText: "license details"
    }
];
